import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sf-site" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_cmp = _resolveComponent("loading-cmp")!
  const _component_error_cmp = _resolveComponent("error-cmp")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading_cmp),
    _createVNode(_component_error_cmp),
    _createVNode(_component_router_view)
  ]))
}